"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var rocketchat_redux_1 = require("@reaction-club/rocketchat-redux");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var ChatQueueBroker = /** @class */ (function (_super) {
    __extends(ChatQueueBroker, _super);
    function ChatQueueBroker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false
        };
        return _this;
    }
    ChatQueueBroker.prototype.render = function () {
        return null;
    };
    ChatQueueBroker.prototype.prepareAttachments = function (attachments) {
        return __awaiter(this, void 0, void 0, function () {
            var attachment, onUpload, rcAttachment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attachment = attachments === null || attachments === void 0 ? void 0 : attachments[0];
                        if (!attachment)
                            return [2 /*return*/, null];
                        onUpload = this.props.onUpload;
                        return [4 /*yield*/, onUpload(attachment)];
                    case 1:
                        rcAttachment = _a.sent();
                        if (!rcAttachment)
                            return [2 /*return*/, null];
                        return [2 /*return*/, [rcAttachment]];
                }
            });
        });
    };
    ChatQueueBroker.prototype.sendMessage = function (_a) {
        var queue_id = _a._id, text = _a.msg, attachments = _a.attachments;
        return __awaiter(this, void 0, void 0, function () {
            var _b, room, sendQueuedMessage, removeMessageFromQueue, payload, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = this.props, room = _b.room, sendQueuedMessage = _b.sendQueuedMessage, removeMessageFromQueue = _b.removeMessageFromQueue;
                        _c = {
                            roomId: room._id,
                            text: text
                        };
                        return [4 /*yield*/, this.prepareAttachments(attachments)];
                    case 1:
                        payload = (_c.attachments = (_d.sent()) || [],
                            _c);
                        return [4 /*yield*/, sendQueuedMessage(payload)];
                    case 2:
                        _d.sent();
                        return [4 /*yield*/, removeMessageFromQueue(queue_id)];
                    case 3:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatQueueBroker.prototype.checkForQueued = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isActive, _a, room, setQueueError, messageQueue, message, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isActive = this.state.isActive;
                        if (isActive)
                            return [2 /*return*/, null];
                        _a = this.props, room = _a.room, setQueueError = _a.setQueueError;
                        messageQueue = lodash_1["default"].filter(room.messageQueue || [], function (message) { return !message.isErrored; });
                        if (lodash_1["default"].isEmpty(messageQueue))
                            return [2 /*return*/, null];
                        message = messageQueue[0];
                        // return null
                        this.setState({ isActive: true });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.sendMessage(message)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _b.sent();
                        return [4 /*yield*/, setQueueError()];
                    case 4:
                        _b.sent();
                        console.warn('Error during send queued message: ', e_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.setState({ isActive: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatQueueBroker.prototype.componentDidMount = function () {
        this.checkForQueued();
    };
    ChatQueueBroker.prototype.componentDidUpdate = function () {
        this.checkForQueued();
    };
    return ChatQueueBroker;
}(react_1.PureComponent));
var mapDispatchToProps = function (dispatch, _a) {
    var room = _a.room;
    return ({
        sendQueuedMessage: function (payload) {
            return dispatch(rocketchat_redux_1.ChatDispatcher.sendQueuedMessage(room._id, payload));
        },
        removeMessageFromQueue: function (queue_id) {
            return dispatch(rocketchat_redux_1.ChatDispatcher.actions.removeMessageFromQueue({ roomId: room._id, _id: queue_id }));
        },
        setQueueError: function () { return dispatch(rocketchat_redux_1.ChatDispatcher.actions.setQueueError({ roomId: room._id, isErrored: true })); }
    });
};
exports["default"] = react_redux_1.connect(function (state) { return ({}); }, mapDispatchToProps)(ChatQueueBroker);
